<template>
  
  <main class="main">
    
    <div class="not-found not-found_page">
      
      <div class="not-found__image">

        <img src="/static/404.svg">

      </div>

      <div class="not-found__caption">Oops, there&rsquo;s a&nbsp;problem. The page you are looking for is&nbsp;not here (anymore). <router-link class="link link_black" to="/">Go to main page</router-link>.</div>

    </div>

  </main>

</template>

<script>
  export default {
    name: 'NotFoundPage',
  };
</script>


// WEBPACK FOOTER //
// src/pages/not-found/Index.vue